export const POM_EUROPEAN_TREND_COLORS = ['#1E4E79'];
export const CS_EUROPEAN_TREND_COLORS = ['#6D9D0F'];

export const POM_TREND_BY_COUNTRY_COLORS = [
  '#2629A0',
  '#5B9BD5',
  '#BDD7EE',
  '#9CC3E5',
  '#2E75B5',
  '#1E4E79',
  '#2629A0'
];
export const CS_TREND_BY_COUNTRY_COLORS = [
  '#608713',
  '#A9D18E',
  '#2BFF75',
  '#48E756',
  '#65D038',
  '#83B81A',
  '#6D9D0F'
];
export const BENCHMARK_BY_YEAR_AREA_COLOR = '#5edfff';
export const BENCHMARK_BY_YEAR_COLORS = [
  '#2f7ed8',
  '#0D233A',
  '#8BBC21',
  '#910000',
  '#492970',
  '#f28f43',
  '#1aadce',
  '#2629A0',
];

export const POM_COUNTRY_VS_WF_COLORS = ['#2629A0', '#83B81A'];
export const CS_COUNTRY_VS_WF_COLORS = ['#B8341A', '#83B81A'];

export const COMPOSITION_COLORS = [
  '#2f7ed8',
  '#0D233A',
  '#8BBC21',
  '#910000',
  '#1AADCE',
  '#492970',
  '#F28F43',
  '#43a3f2',
  '#2f72a9',
  '#f2d043',
  '#a9922f',
];

export const VCT_COLORS = ['#FFC000'];
export const VCT_NEGATIVE_COLOR = '#8000FF';

export const RETURN_TREND_BY_COUNTRY = [
  '#E4D2F2',
  '#C5AFD5',
  '#9B80AE',
  '#6E4E85',
  '#411C5C'
];
export const RETURN_BY_YEAR = ['#7949a0'];
export const RETURN_BY_YEAR_OWN_USER = ['#411C5C'];

export const COST_COLORS = ['#7F6000FF', '#BABE02', '#BF9000', '#807900'];

export const COST_PIE_OPERATIONS_COLORS = [
  '#507010',
  '#85ba1a',
  '#afe545',
];
export const COST_PIE_OVERHEAD_COLORS = [
  '#021628',
  '#074279',
  '#0b6ec9',
  '#3699f4',
  '#86c2f8',
];

export const INTELLIGENCE_BAR_COLOR = [
  '#4472c4'
];

export const INTELLIGENCE_PIE_COLORS = [
  '#3568c1',
  '#eb7c34',
  '#c3c2be',
  '#fbc405',
  '#4c93d2',
  '#6db040'
];


